import { useState } from "react";

const useData = () => {
  const [tecnologias] = useState([
    { name: "CSS3", imagen: "/images/tecnology/css3.svg" },
    { name: "PHP", imagen: "/images/tecnology/php.svg" },
    { name: "HTML5", imagen: "/images/tecnology/html5.svg" },
    { name: "JavaScript", imagen: "/images/tecnology/javascript.svg" },
    { name: "JQuery", imagen: "/images/tecnology/jquery.svg" },
    { name: "NodeJS", imagen: "/images/tecnology/node-js.svg" },
    { name: "Laravel", imagen: "/images/tecnology/laravel.svg" },
    { name: "Blade", imagen: "/images/tecnology/blade.svg" },
    { name: "React", imagen: "/images/tecnology/react.svg" },
    { name: "Blazor", imagen: "/images/tecnology/blazor.svg" },
    { name: "C#", imagen: "/images/tecnology/c-sharp.svg" },
    { name: "Java", imagen: "/images/tecnology/java.svg" },
    { name: "Android", imagen: "/images/tecnology/android.svg" },
    { name: "PhpMyAdmin", imagen: "/images/tecnology/phpmyadmin.svg" },
    { name: "MySQL", imagen: "/images/tecnology/mysql.svg" },
    { name: "SQL Server", imagen: "/images/tecnology/sql.svg" },
    { name: "Linux", imagen: "/images/tecnology/linux.svg" },
    { name: "Ubuntu", imagen: "/images/tecnology/ubuntu.svg" },
    { name: "Photoshop", imagen: "/images/tecnology/photoshop.svg" },
    { name: "Premiere", imagen: "/images/tecnology/premiere.svg" },
    { name: "Figma", imagen: "/images/tecnology/figma.svg" },
    { name: "Prompt Writing", imagen: "/images/tecnology/ai.svg" },
    { name: "Wordpress", imagen: "/images/tecnology/wordpress.svg" },
  ]);

  const [proyectos] = useState([

    {
      tecnologias: "Laravel, PHP, JQuery, Blade, MySql",
      descripcion: "Proyecto de fin de carrera. Se trata de una web profesional desarrollada desde 0 en Laravel para la reserva de viajes de lujo con registro de usuarios, CMS para administrador, CMS para proveedores y perfil de reservas de usuario. La web se está adaptando actualmente para una empresa que se interesó en su desarrollo.",
      titulo: "Utopik Travel",
      git: "https://github.com/Sergiosm77/utopik-proyecto",
      web: "https://utopik.sergiosm.es",
      imagen: "/images/works/utopik.jpg",
      ref: "proyecto1"
    },
    {
      tecnologias: "Laravel, PHP, JQuery, Blade, MySql",
      descripcion: "Página para una asociación de personas afectadas por el suicidio de La Rioja. La página, creada en Laravel, disponde de un CMS para usuarios donde pueden publicar sus artículos. Disponde de un CMS para administradores donde pueden verificar artículos y gestionar dinámicamente contenidos de la página.",
      titulo: "Color a la Vida",
      git: "",
      web: "https://color.sergiosm.es",
      imagen: "/images/works/color.jpg",
      ref: "proyecto2"
    },
    {
      tecnologias: "PHP, HTML5, CSS3, JS, MySql",
      descripcion: "Web de empresa. Mecánica y venta de bicicletas. Dispone de un menú de administrador para gestión de contenidos. Desarrollada en PHP, HTML y JS puro.",
      titulo: "Mekabike",
      git: "",
      web: "https://mekabike.es",
      imagen: "/images/works/mekabike_color.jpg",
      ref: "proyecto3"
    },
    {
      tecnologias: "Android, Java, Google API, Volley, PHP, MySql",
      descripcion: "Aplicación para el cálculo de rutas e información de autobuses. Desarrollada en Java, dispone de microservicios para el tratamiento de datos.",
      titulo: "Takemitu Logroño",
      git: "https://github.com/Sergiosm77/takemitu",
      web: "https://play.google.com/store/apps/details?id=com.saraodigital.takemitu",
      imagen: "/images/works/samples/playstore_takemitu.jpg",
      ref: "proyecto4"
    },
    {
      tecnologias: "Android, Java, API REST, Volley, Glide, PHP, MySql",
      descripcion: "Aplicación para la gestión de menús de restaurantes. Es una aplicación avanzada en Java donde los restaurantes pueden publicar dinámicamente sus menús. Los clientes, tienen un registro que les permite crear comentarios y realizar pedidos.",
      titulo: "La Karta",
      git: "https://github.com/Sergiosm77/lakarta",
      web: "",
      imagen: "/images/works/portada_store.jpg",
      ref: "proyecto5"
    },
    {
      tecnologias: "PHP, HTML5, CSS3, JS, MySql",
      descripcion: "Portafolio de vídeos de bodas. Es una página sencilla para mostrar servicios de vídeo. Esta página se está actualizando en Laravel para añadir un CMS para clientes.",
      titulo: "Sarao Digital",
      git: "",
      web: "https://saraodigital.com",
      imagen: "/images/works/samples/saraodigital.jpg",
      ref: "proyecto6"
    },
    {
      tecnologias: "REACT, HTML5, CSS3, JS",
      descripcion: "La página que estás viendo ahora mismo. Desarrollada en REACT.",
      titulo: "Página actual",
      git: "",
      web: "",
      imagen: "/images/works/sergio.jpg",
      ref: "proyecto7"
    },

  ]);

  return { tecnologias, proyectos };
};

export default useData;
